"use strict";

function setGlobal(analytics) {
  if (typeof window !== 'undefined') {
    window.analytics = analytics;
  }
}
module.exports = {
  setGlobal
};